/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _MiciCrohnSurveyEditionForm;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { service } from "@ember/service";
import CrohnSurveyFilledJournalEvent from "core/models/crohn-survey-filled-journal-event";
import SemeiaSessionService from "core/services/session";
import MiciBaseEditionFormEditionForm from "../base-edition-form/edition-form";
let MiciCrohnSurveyEditionForm = (_class = (_MiciCrohnSurveyEditionForm = class MiciCrohnSurveyEditionForm extends MiciBaseEditionFormEditionForm {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
  }
  get forcDisplayName() {
    return this.session.medic ? "Questionnaire Crohn" : "Symptômes";
  }
  get currentSections() {
    return ["stoolsNumber", ...this.abdominalPainSections, "wellBeing", ...this.anusSections, ...this.fistulasSections, ...this.articularPainSections, "mouthUlcers", "skinSymptoms", ...this.eyeSymptomsSections, ...this.feverSections, "weight", "repeatedVomiting", "transitBlockage"];
  }
  get abdominalPainSections() {
    if (this.changeset.get("abdominalPain")) {
      return ["abdominalPain", "abdominalPainIntensity"];
    }
    return ["abdominalPain"];
  }
  get anusSections() {
    if (this.changeset.get("anusSymptoms")) {
      return ["anusSymptoms", "anusSymptomsFrequency"];
    }
    return ["anusSymptoms"];
  }
  get fistulasSections() {
    if (this.changeset.get("hasFistulas")) {
      return ["hasFistulas", "fistulasPain", "fistulasEmbarrassment", "fistulasFlow", "fistulasPainSkin", "fistulasMovement"];
    }
    return ["hasFistulas"];
  }
  get articularPainSections() {
    if (this.changeset.get("articularPain")) {
      return ["articularPain", "articularPainSeverity"];
    }
    return ["articularPain"];
  }
  get eyeSymptomsSections() {
    if (this.changeset.get("eyeSymptoms")) {
      return ["eyeSymptoms", "eyeSymptomsRedEye", "eyeSymptomsPainful", "eyeSymptomsSight"];
    }
    return ["eyeSymptoms"];
  }
  get feverSections() {
    if (this.changeset.get("fever")) {
      return ["fever", "feverLevel"];
    }
    return ["fever"];
  }
}, _defineProperty(_MiciCrohnSurveyEditionForm, "forcDisplayName", "Questionnaire sur ma maladie"), _defineProperty(_MiciCrohnSurveyEditionForm, "fullComponentId", "mici/crohn-survey-edition-form"), _defineProperty(_MiciCrohnSurveyEditionForm, "journalEventClass", CrohnSurveyFilledJournalEvent), _MiciCrohnSurveyEditionForm), _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MiciCrohnSurveyEditionForm as default };